"use client";
import Image from "next/image";
import Link from "next/link";
import "../../css/Header.css";
import logo from '../../assets/images/logo.svg'
import { useEffect, useState } from "react";
import {usePathname} from 'next/navigation';

export default function Header() {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const pathname = usePathname();

  const toggleMobileMenu = () => {
    setIsMobileOpen(!isMobileOpen);
  };
  const [isScrolled, setIsScrolled] = useState(false);

useEffect(() => {
  const handleScroll = () => {
    setIsScrolled(window.scrollY > 50);
  };
  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

useEffect(() => {
  if (isMobileOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
  return () => {
    document.body.style.overflow = "";
  };
}, [isMobileOpen]);


  return (
    <header className={`basic-header ${isScrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <Link href="/" className="header-logo">
          <Image
            src={logo}
            alt="Company Logo"
            width={180}
            height={50}
            priority
          />
        </Link>

        <nav className="header-nav">
        <Link href="/" className={pathname === "/" ? "active" : ""}>Home</Link>
        <Link href="/about" className={pathname === "/about" ? "active" : ""}>About Us</Link>
        <Link href="/features" className={pathname === "/features" ? "active" : ""}>Features</Link>
        <Link href="/challenges" className={pathname === "/challenges" ? "active" : ""}>Challenges</Link>
        <Link href="/outcomes" className={pathname === "/outcomes" ? "active" : ""}>Outcomes</Link>
        <Link href="/time-savings" className={pathname === "/time-savings" ? "active" : ""}>Time Savings</Link>
        <Link href="/contact" className={pathname === "/contact" ? "active" : ""}>Contact Us</Link>
        <Link href="/login" className={`header-link-login ${pathname === "/login" ? "active" : ""}`}>Login</Link>
        <Link href="/signup" className={`header-link-register ${pathname === "/signup" ? "active" : ""}`}>Register</Link>
        </nav>

        <button className="hamburger" onClick={toggleMobileMenu} aria-label="Toggle menu">
          {isMobileOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>

        <nav className={`mobile-menu ${isMobileOpen ? "open" : ""}`}>
          <Link href="/" className={pathname === "/" ? "active" : ""} onClick={() => setIsMobileOpen(false)}>Home</Link>
          <Link href="/about" className={pathname === "/about" ? "active" : ""} onClick={() => setIsMobileOpen(false)}>About Us</Link>
          <Link href="/features" className={pathname === "/features" ? "active" : ""} onClick={() => setIsMobileOpen(false)}>Features</Link>
          <Link href="/challenges" className={pathname === "/challenges" ? "active" : ""} onClick={() => setIsMobileOpen(false)}>Challenges</Link>
          <Link href="/outcomes" className={pathname === "/outcomes" ? "active" : ""} onClick={() => setIsMobileOpen(false)}>Outcomes</Link>
          <Link href="/time-savings" className={pathname === "/time-savings" ? "active" : ""} onClick={() => setIsMobileOpen(false)}>Time Savings</Link>
          <Link href="/contact" className={pathname === "/contact" ? "active" : ""} onClick={() => setIsMobileOpen(false)}>Contact Us</Link>
          <Link href="/login" className={`header-link-login ${pathname === "/login" ? "active" : ""}`} onClick={() => setIsMobileOpen(false)}>Login</Link>
          <Link href="/signup" className={`header-link-register ${pathname === "/signup" ? "active" : ""}`} onClick={() => setIsMobileOpen(false)}>Register</Link>
        </nav>
      </div>
    </header>
  );
}